module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic15.aaf66a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic15.png
// module id = 493
// module chunks = 1